var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 3.5C5.28683 3.5 5.46705 3.59099 5.58008 3.74512L6.32031 4.75488C6.43328 4.90886 6.61275 4.99989 6.80371 5H12.4004C12.7315 5.00021 12.9998 5.26855 13 5.59961V11.9004C12.9998 12.2315 12.7315 12.4998 12.4004 12.5H3.59961C3.26855 12.4998 3.00021 12.2315 3 11.9004V4.09961C3.00021 3.76855 3.26855 3.50021 3.59961 3.5H5.0957ZM9.4873 6.13574C9.249 5.90552 8.86892 5.9121 8.63867 6.15039C8.40846 6.3887 8.41503 6.76878 8.65332 6.99902L9.58496 7.89941H5.07031C4.73894 7.89941 4.4707 8.16863 4.4707 8.5C4.47081 8.83128 4.73901 9.09961 5.07031 9.09961H9.58594L8.65332 10.001C8.41517 10.2312 8.40847 10.6114 8.63867 10.8496C8.86894 11.0878 9.24905 11.0935 9.4873 10.8633L11.4873 8.93164C11.6043 8.81863 11.6699 8.66263 11.6699 8.5C11.6699 8.33733 11.6043 8.18141 11.4873 8.06836L9.4873 6.13574Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveTo);
export default __webpack_public_path__ + "static/media/Move_to.c7f2ddaf3e928454c2f7c5f14bfcb7e2.svg";
export { ForwardRef as ReactComponent };